import React from "react";
import classNames from "./Upload.module.css";

const Upload = ({ i }) => {
  return (
    <div className={classNames.upload_image}>
      <label htmlFor={i.id}>Choose File</label>
      <input
        type="file"
        id={i.id}
        onChange={(e) => {
          i.setFn(e.target.files[0]);
        }}
      />
    </div>
  );
};

export default Upload;
